import { gql } from '@apollo/client';

export const NEW_AUX_MACHINERY = gql`
  fragment NewAuxMachine on AuxMachine {
    id
    auxMachineId
    description
    type
    typeOfMeasurement
    isInternal
    auxMachineTypeIDs
    measureTypeIDs
  }
`;
